import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Input from '@material-ui/core/Input';
import { Colors } from '../../themes';
import SvgIcon from '../../icons/SvgIcon';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme) => ({
  selectContainer: {
    marginTop: 14,
    display: 'flex',
    flexWrap: 'wrap',
    color: Colors.white,
  },
  singleElement: {
    flex: '0 1 100%',
  },
  lowMarginTop: {
    marginTop: 1,
  },
  formControl: {
    minWidth: 120,
  },
  formStyleFormControl: {
    marginLeft: 0,
    '& .MuiInputLabel-shrink': {
      fontSize: 13,
    },
    '& .MuiSelect-select:focus': {
      background: Colors.white,
    },
  },
  lightThemeFormControl: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: Colors.disabledGrey,
    },
    '& .MuiInputBase-input': {
      color: Colors.black,
    },
  },
  select: {
    paddingTop: 2,
    marginBottom: -2,
  },
  formStyleSelect: {
    '& .MuiSelect-root': {
      paddingLeft: 0,
    },
  },
  logoAndDropDownContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 10,
  },
  inputSelect: {
    textAlign: 'right',
    paddingLeft: 10,
  },
  darkThemeGrey: {
    color: Colors.lightGrey,
    '& .Mui-disabled': {
      color: Colors.disabledGrey,
    },
  },
  error: {
    color: Colors.errorRed,
  },
  lightThemeGrey: {
    color: Colors.disabledGrey,
  },
  darkThemeUnderline: {
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${Colors.lightGrey}`,
    },
  },
  lightThemeUnderline: {
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${Colors.hoverGrey}`,
    },
  },
}));

const CustomSelect = (props) => {
  const {
    selectData,
    selectLabel,
    selectValue,
    onSelect,
    accessValue,
    accessLabel,
    noEntry,
    selectWidth,
    lightTheme,
    formStyle,
    disabled,
    error,
    helperText,
    required,
    lowMarginTop,
    singleElement,
    enableCapabilityFilter,
    onKeyDown,
  } = props;
  const classes = useStyles();
  const handleChange = (event) => {
    onSelect(event.target.value);
  };
  return (
    <div
      className={clsx([
        classes.selectContainer,
        lowMarginTop && classes.lowMarginTop,
        singleElement && classes.singleElement,
      ])}
    >
      <FormControl
        className={clsx([
          classes.formControl,
          lightTheme && classes.lightThemeFormControl,
          formStyle && classes.formStyleFormControl,
        ])}
        error={error}
        required={required}
      >
        <InputLabel className={lightTheme ? classes.lightThemeGrey : classes.darkThemeGrey} htmlFor={selectLabel}>
          {selectLabel}
        </InputLabel>
        <Select
          defaultValue={''}
          disabled={disabled}
          classes={{ icon: error ? classes.error : lightTheme ? classes.lightThemeGrey : classes.darkThemeGrey }}
          className={clsx([classes.select, formStyle && classes.formStyleSelect])}
          style={{ width: selectWidth || 120 }}
          // value={disabled ? noEntry : selectValue}
          value={selectValue}
          onChange={handleChange}
          IconComponent={disabled || selectData.length === 1 ? SvgIcon : ExpandMoreIcon}
          input={
            <Input
              classes={{
                underline: lightTheme ? classes.lightThemeUnderline : classes.darkThemeUnderline,
              }}
            />
          }
        >
          {!selectData || selectData.length === 0 ? (
            <MenuItem key="0" value={noEntry}>
              {noEntry}
            </MenuItem>
          ) : selectData.length === 1 ? (
            <MenuItem value={accessValue ? selectData[0][accessValue] : selectData[0]}>
              {accessLabel ? selectData[0][accessLabel] : selectData[0]}
            </MenuItem>
          ) : (
            selectData.map((entry, index) => (
              <MenuItem
                key={index}
                disabled={enableCapabilityFilter && !entry.capability}
                onKeyDown={onKeyDown}
                value={accessValue ? entry[accessValue] : entry}
              >
                {accessLabel ? entry[accessLabel] : entry}
              </MenuItem>
            ))
          )}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default CustomSelect;
